import React from 'react';
import { Box, Card, CardActionArea, CardContent, CardMedia, Link, Typography } from '@mui/material';
import { PATH } from '../../../../config/path';
import { Link as ReactRouterLink } from 'react-router-dom';

const TopDestinationCard = ({ topDest }) => {
  const { city_image, city_image_title, name, city_image_alt } = topDest;

  const nameToSlug = name
  .toLowerCase()
  .trim()
  .replace(/\s+/g, '-')
  .replace(/[^\w-]+/g, '');


  return (
    <Box sx={{ px: 1 }}> {/* 👈 Add horizontal spacing here */}
      <Link
        component={ReactRouterLink}
        // to={`${PATH.DESTINATION}?region=${name}`}
        to={`${PATH.DESTINATION}/${nameToSlug}`}
        underline="none">
        <Card
          sx={{
            position: 'relative',
            border: 'none',
            borderRadius: 2,  // optional for rounded look
            overflow: 'hidden', // keeps rounded edges clean
          }}>
          <CardActionArea
            sx={[{ '.MuiCardActionArea-focusHighlight': { opacity: 0.4 } }]}>
            <CardMedia
              component="img"
              image={city_image}
              alt={city_image_alt ?? city_image_title}
              loading="lazy"
              width="auto"
              height="auto"
              sx={{
                width: {
                  xs: 200,
                  md: '100%',
                },
                height: 200,
                objectFit: 'cover',
              }}
            />
            <CardContent
              sx={{
                position: 'absolute',
                zIndex: 1,
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                p: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}>
              <Box>
                <Typography
                  variant="h2"
                  sx={{
                    color: '#fff',
                    fontSize: {
                      xs: '1.5rem',
                    },
                    fontWeight: 500,
                  }}>
                  {name}
                </Typography>
              </Box>
            </CardContent>
          </CardActionArea>
        </Card>
      </Link>
    </Box>
  );
};

export default TopDestinationCard;
